import axiosConfig from './axiosConf'
import wsConf from './wsConf'

export default {
  install (Vue, options) {
    Vue.prototype.wsConf = wsConf
    Vue.prototype.baseUrl = axiosConfig.baseUrl
    Vue.prototype.fileBase = axiosConfig.baseUrl + 'file/'
    Vue.prototype.fileThumbBase = axiosConfig.baseUrl + 'file/thumb/'
    Vue.prototype.uploadActionUrl = axiosConfig.baseUrl + 'file/importexcel'
    Vue.prototype.domain = axiosConfig.domain
    Vue.prototype.login = axiosConfig.baseUrl + '#/login'
    Vue.prototype.FileUploadBase = axiosConfig.FileUploadBase
    Vue.prototype.FileThumbBase = axiosConfig.FileThumbBase
    Vue.prototype.FileThumbBase_entry = axiosConfig.FileThumbBase_entry
    Vue.prototype.FileUploadBase_entry = axiosConfig.FileUploadBase_entry
  }
}



// WEBPACK FOOTER //
// ./src/config/index.js